module.exports = __webpack_public_path__ + "screenshot_1.62bdf84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/Guides/screenshot_1.png
// module id = 3002
// module chunks = 0